import { AppRoutes } from "@/config/router";
import useAppContext from "@/utilities/hooks/useAppContext";
import { faDownload, faPrint } from "@fortawesome/free-solid-svg-icons";
import Page, { PageActionsType } from "components/common/page/Page";
import AccommodationEventDatalist, { AccommodationEventDatalistType } from "components/entities/accommodation/events/AccommodationEventDatalist";
import { uuid } from "config/app-constants";
import { Conditions } from "utilities/datalist/datalist-filter-utilities";
import { DateUtil } from "utilities/date-utilities";

const AccommodationEventPage = () => {
    const context = useAppContext();
    const pageActions: PageActionsType = [
        {
            icon: faPrint,
            link() {
                context.navigate(AppRoutes.PRINT_ACCOMMODATION_EVENT);
            },
            title: 'Print',
            name: 'print'
        },
        {
            icon: faDownload,
            link() {
                const value = document.querySelector('input[type=search]')?.getAttribute('value');
                window.location = `/api/AccommodationPrint/ExportEvents?take=50&searchText=${value || ''}` as any;
            },
            title: 'Download',
            name: 'download'
        },
    ]

    const config: AccommodationEventDatalistType['config'] = {
        dataSource: {
            filter: {
                logic: 'or',
                id: uuid(),
                filters: [
                    {
                        id: uuid(),
                        name: 'date',
                        type: 'dateOnly',
                        condition: Conditions.gte,
                        value: DateUtil.toIsoDate()
                    },
                    {
                        id: uuid(),
                        name: 'isDone',
                        type: 'boolean',
                        condition: Conditions.eq,
                        value: false
                    }
                ]
            }
        }
    };

    return (
        <Page wFull title="pages.accommodation.event.list" actions={pageActions}>
            <AccommodationEventDatalist
                config={config}
                name="event-datalist-page"
                addNew
            />
        </Page>
    );
};

export default AccommodationEventPage;
